export const badgeColors = [
  "bg-blue-100 text-blue-800",
  "bg-green-100 text-green-800",
  "bg-yellow-100 text-yellow-800",
  "bg-purple-100 text-purple-800",
  "bg-pink-100 text-pink-800",
  "bg-indigo-100 text-indigo-800",
  "bg-brand-100 text-brand-800",
  "bg-orange-100 text-orange-800",
  "bg-teal-100 text-teal-800",
  "bg-rose-100 text-rose-800",
];

export const questionsList = [
  "Tell us about yourself",
  "Why do you think you're good at your specialty?",
  "What is your biggest achievement?",
  "Tell us about your soft skills?",
  "What was your biggest challenge and how did you overcome it?",
  "Want to add anything else?",
];
